import { createSlice } from "@reduxjs/toolkit";

const getLocalTag = () => {
    try {
        const val = localStorage.getItem('mainTag');
        return val ? JSON.parse(val) : null;
    } catch {
        return null;
    }
};

const getLocalTagActive = () => {
    try {
        const val = localStorage.getItem('mainTagActive');
        return val ? JSON.parse(val) : '/SysHome';
    } catch {
        return '/SysHome';
    }
};

const tagSlice = createSlice({
    name: "tag",
    initialState: () => {
        const localTag = getLocalTag();
        const localActive = getLocalTagActive();
        
        if (localTag && localTag.length > 0) {
            return {
                value: localTag,
                activeKey: localActive,
            }
        }
        
        return {
            value: [{ key: '/SysHome', label: '首页' }],
            activeKey: '/SysHome'
        }
    },
    reducers: {
        addTag: (state, action) => {
            const { key, label } = action.payload;
            
            // 检查是否已存在
            const exists = state.value.some(item => item.key === key);
            if (!exists) {
                state.value.push({ key, label });
                state.activeKey = key;
                
                // 同步到本地存储
                localStorage.setItem('mainTag', JSON.stringify(state.value));
                localStorage.setItem('mainTagActive', JSON.stringify(state.activeKey));
            } else {
                // 如果已存在，只激活
                state.activeKey = key;
                localStorage.setItem('mainTagActive', JSON.stringify(state.activeKey));
            }
        },
        deleteTag: (state, action) => {
            const keyToRemove = action.payload;
            
            // 过滤掉要删除的标签
            state.value = state.value.filter(item => item.key !== keyToRemove);
            
            // 如果删除的是当前激活的标签，则激活最后一个标签或首页
            if (state.activeKey === keyToRemove) {
                state.activeKey = state.value.length > 0 
                    ? state.value[state.value.length - 1].key 
                    : '/SysHome';
            }
            
            // 同步到本地存储
            localStorage.setItem('mainTag', JSON.stringify(state.value));
            localStorage.setItem('mainTagActive', JSON.stringify(state.activeKey));
        },
        clickTag: (state, action) => {
            const key = action.payload;
            
            // 确保要激活的标签存在
            if (state.value.some(item => item.key === key)) {
                state.activeKey = key;
                localStorage.setItem('mainTagActive', JSON.stringify(state.activeKey));
            }
        },
        resetMain: (state) => {
            // 重置为初始值
            state.value = [{ key: '/SysHome', label: '首页' }];
            state.activeKey = '/SysHome';
            
            // 清理 localStorage
            localStorage.removeItem('mainTag');
            localStorage.removeItem('mainTagActive');
        }
    }
});

export const { addTag, deleteTag, clickTag, resetMain } = tagSlice.actions;
export const { reducer: tagReducer } = tagSlice;